var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "results-container", attrs: { disabled: _vm.request } },
    [
      _vm.request
        ? _c("span", {
            staticClass: "fa fa-spinner fa-spin searchIndicator",
            staticStyle: { position: "absolute", left: "50%", top: "15px" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.resultsHaveData
        ? _c(
            _vm.resultComponentName,
            _vm._b(
              {
                tag: "component",
                on: {
                  sort: function ($event) {
                    _vm.sort = $event
                  },
                  viewgroup: function ($event) {
                    _vm.originalGroupBySettings = {
                      page: _vm.page,
                      sort: _vm.sort,
                    }
                    _vm.viewGroup = $event.id
                    _vm._viewGroupName = $event.displayName
                  },
                },
              },
              "component",
              _vm.resultComponentData,
              false
            ),
            [
              _c("BreadCrumbs", {
                attrs: {
                  slot: "breadcrumbs",
                  crumbs: _vm.breadCrumbs,
                  disabled: !!_vm.request,
                },
                slot: "breadcrumbs",
              }),
              _vm._v(" "),
              _c("Totals", {
                staticClass: "result-totals",
                attrs: {
                  slot: "totals",
                  initialResults: _vm.results,
                  type: _vm.id,
                  indexId: _vm.indexId,
                },
                on: {
                  update: function ($event) {
                    _vm.paginationResults = $event
                  },
                },
                slot: "totals",
              }),
              _vm._v(" "),
              _c("GroupBy", {
                attrs: {
                  slot: "groupBy",
                  type: _vm.id,
                  disabled: !!_vm.request,
                  originalGroupBySettings: _vm.originalGroupBySettings,
                },
                on: { viewgroupLeave: _vm.leaveViewgroup },
                slot: "groupBy",
              }),
              _vm._v(" "),
              _c("Pagination", {
                staticStyle: { display: "block", margin: "10px 0" },
                attrs: {
                  slot: "pagination",
                  page: _vm.pagination.shownPage,
                  maxPage: _vm.pagination.maxShownPage,
                  disabled: !!_vm.request,
                },
                on: {
                  change: function ($event) {
                    _vm.page = $event
                  },
                },
                slot: "pagination",
              }),
              _vm._v(" "),
              _c("Sort", {
                attrs: {
                  slot: "sort",
                  hits: _vm.isHits,
                  docs: _vm.isDocs,
                  groups: _vm.isGroups,
                  corpus: _vm.corpus,
                  annotations: _vm.sortAnnotations,
                  metadata: _vm.sortMetadata,
                  disabled: !!_vm.request,
                },
                slot: "sort",
                model: {
                  value: _vm.sort,
                  callback: function ($$v) {
                    _vm.sort = $$v
                  },
                  expression: "sort",
                },
              }),
              _vm._v(" "),
              _vm.exportEnabled
                ? _c("Export", {
                    attrs: {
                      slot: "export",
                      results: _vm.results,
                      type: _vm.id,
                      disabled: !!_vm.request,
                      annotations: _vm.exportAnnotations,
                      metadata: _vm.exportMetadata,
                    },
                    slot: "export",
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm.results
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v("No results found."),
          ])
        : !_vm.valid
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v(
              "\n\t\tThis view is inactive because no search criteria for words were specified.\n\t"
            ),
          ])
        : _vm.error != null
        ? _c("div", { staticClass: "no-results-found" }, [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _c("br"),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.error) } }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: {
                  type: "button",
                  title: "Try again with current search settings",
                },
                on: {
                  click: function ($event) {
                    return _vm.markDirty()
                  },
                },
              },
              [_vm._v("Try again")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("Debug", [
        _c("div", [
          _c("hr"),
          _vm._v(" "),
          _c("div", [_vm._v("BlackLab response: ")]),
          _vm._v(" "),
          _vm.results
            ? _c("pre", [
                _vm._v(
                  _vm._s(JSON.stringify(_vm.results.summary, undefined, 2))
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }